/* import __COLOCATED_TEMPLATE__ from './about-simple-text-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();